









































































import { defineComponent, ref, inject, computed } from '@vue/composition-api';
import { $K18n } from '@k18n/vue2-k18n-next';
import cookies from 'js-cookie';
import useStore, { FormatTaskItem } from '../my/store';
import { showErrorToast, yoda } from '@/utils/yoda';
import { TaskTypeEnum, missionInfo, PAGE_RULE, PAGE_HOME, PAGE_SHARE_PARAMS, LAUNCH_OPTION_PARAM, SHARE_CAPTION, SHARE_TOTAL_MAP, DEFAULT_SHARE } from '../config';
import { openPage } from '@/utils/webview';
import { getLangCode } from '@/utils/getLanguage';
import { NOT_LOGIN_RES_CODE, isYodaEnv } from '@/utils/env';
import share from '@/utils/share';
import kwailog from '@/utils/kibtLogger';
import { getQueryParams } from '@/utils/util';
import { shareCallback } from '../service';
import { batchFollow } from '@/services/user';
import { setStorage } from '@/utils/storage';

export default defineComponent({
    name: 'mission',
    setup() {
        const $k18n = inject('$k18n') as $K18n;
        const { isLiving } = getQueryParams();

        const langCode = getLangCode();

        const code = langCode?.split('-')[0];

        const wrapText = ['es', 'id', 'pt', 'tr'].includes(langCode.split('-')[0]);

        const store = useStore();

        const list = ref([]);

        const curBucket = computed(() => {
            return store.homeData.bucket || cookies.get('bucket') || store.shareBucket;
        });

        const shareImg = computed(() => {
            if (!curBucket.value) return DEFAULT_SHARE;
            const obj: any = SHARE_TOTAL_MAP[curBucket.value as keyof typeof SHARE_TOTAL_MAP];
            return obj?.[code as keyof typeof obj] || obj?.en || DEFAULT_SHARE;
        });

        const doTask = (item: FormatTaskItem) => {
            if (item.status === 101 && item.type !== TaskTypeEnum.SHARE) return; // 已完成

            kwailog.sendClick({
                action: 'TASK_BTN',
                params: {
                    btn_name: item.type,
                },
            });

            kwailog.sendRadarLog({
                name: 'WARMUP-DO-TASK',
                category: 'kwai-log-live-midyear',
                event_type: 'custom',
                extra_info: JSON.stringify({
                    task_type: item.type,
                }),
            });

            if (item.type === TaskTypeEnum.VIEW) {
                const link = `${PAGE_RULE}&warmtime=${item.target}&warmpoint=${item.point}&livefrom=warmup`;
                openPage(`${link}${store.isLiving ? LAUNCH_OPTION_PARAM : ''}`);
            } else if (item.type === TaskTypeEnum.SHARE) {
                const url = `${window.location.origin}${window.location.pathname}?shareBucket=${store.shareBucket}&uuid=${store.homeData.uuid}${PAGE_SHARE_PARAMS}`;
                share({
                    key: 'global-mid-warmup',
                    siteUrl: url,
                    showFriends: true,
                    caption: $k18n({ id: SHARE_CAPTION }),
                    description: $k18n({ id: 'k_333317' }),
                    imageUrl: shareImg.value,
                }, (data: any) => {
                    if (data && data.result === 1) {
                        // 分享回调
                        // 分享任务未达上限
                        if (store.canAddSharePoint) {
                            shareCallback()
                                .then(res => {
                                    console.log('share callback: ', res);
                                    if (res.result === 1) {
                                        store.showSuccessToast('k_336709', store.sharePointVal);
                                        setTimeout(() => {
                                            store.getHomeData();
                                            store.updateHomeStorage();
                                        }, 1500);
                                    }
                                });
                        }
                    }
                });
            } else if (item.type === TaskTypeEnum.FOLLOW) {
                if (store.isSecondPage) {
                    setStorage('global-midyear-warmup-myrankpos', '1');
                    if (!isYodaEnv) {
                        window.history.go(-1);
                    } else {
                        yoda.ready().then(() => {
                            yoda.component.backOrCloseWeb();
                        });
                    }
                } else {
                    // 分享回流打开 自身就是一级页
                    window.location.replace(`${PAGE_HOME}&source=MY`);
                }
            } else if (item.type === TaskTypeEnum.FANS) {
                window.location.href = 'ikwai://post?tab=live';
            }
        };

        const goFollow = (item: FormatTaskItem) => {
            if (item.status === 101) return;

            kwailog.sendClick({
                action: 'FOLLOW',
            });

            const uid = item.extraInfo?.uid || 0;
            if (!uid) return;
            batchFollow({ toUserIds: [uid]})
                .then(async res => {
                    if (res.result === 1) {
                        store.showSuccessToast('k_336711', store.followPointVal);
                        setTimeout(() => {
                            store.updateHomeStorage();
                            store.getHomeData()
                                .then(() => {
                                    // 手动将follow置灰
                                    store.updateFollowStatus();
                                });
                        }, 1500);
                    } else if (NOT_LOGIN_RES_CODE.includes(res.result)) {
                        await yoda.ready();
                        yoda.component.login();
                    } else {
                        throw new Error();
                    }
                }).catch(() => {
                    showErrorToast();
                });
        };

        return {
            store,
            list,
            TaskTypeEnum,
            missionInfo,
            isLiving,
            wrapText,
            doTask,
            goFollow,
        };
    },
});
